export enum sortTableEnum {
  ascend = 'asc',
  descend = 'desc',
}
